import React from "react";
import FadeInAnimation from "../Common/FadeInAnimation";
import { BiCodeAlt, BiBrain, BiTrendingUp, BiShield, BiRocket, BiUserCheck, BiLogoChrome, BiMobile } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';
import Link from "next/link";

const StartseiteExpertise = () => {
    const { t } = useTranslations();

    return (
        <section className="ptb-100" style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Dekorative Hintergrund-Elemente */}
            <div style={{
                position: 'absolute',
                top: '15%',
                right: '8%',
                width: '180px',
                height: '180px',
                background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.08), rgba(76, 175, 80, 0.08))',
                borderRadius: '50%',
                filter: 'blur(35px)',
                zIndex: '1'
            }}></div>

            <div style={{
                position: 'absolute',
                bottom: '25%',
                left: '5%',
                width: '120px',
                height: '120px',
                background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.06), rgba(76, 175, 80, 0.06))',
                borderRadius: '50%',
                filter: 'blur(25px)',
                zIndex: '1'
            }}></div>


            <div className="container" style={{ position: 'relative', zIndex: '2' }}>


                <FadeInAnimation direction="up" delay={100}>
                    <div className="text-center mb-5">
                        <div style={{
                            display: 'inline-block',
                            background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                            color: 'white',
                            padding: '12px 30px',
                            borderRadius: '30px',
                            fontSize: '14px',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                            marginBottom: '25px',
                            boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                        }}>
                            {t('startseite_expertise_title')}
                        </div>
                        <h2 style={{
                            fontSize: '3rem',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #080a3c, #1a1c4a)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            marginBottom: '30px',
                            lineHeight: '1.2'
                        }}>
                            {t('startseite_expertise_description')}
                        </h2>
                        <p style={{
                            fontSize: '1.2rem',
                            color: '#333',
                            lineHeight: '1.7',
                            maxWidth: '900px',
                            margin: '0 auto 50px',
                            fontWeight: '400'
                        }} dangerouslySetInnerHTML={{ __html: t('startseite_expertise_description2') }} />
                    </div>
                </FadeInAnimation>


                <FadeInAnimation direction="up" delay={200}>
                    <div className="row">

                        <div className="col-lg-4 col-md-6 mb-4">
                            <Link href="/software-development">
                                <div className="expertise-card" style={{
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: '25px',
                                    padding: '35px 30px',
                                    border: '1px solid rgba(89, 189, 101, 0.15)',
                                    height: '100%',
                                    transition: 'all 0.4s ease',
                                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '25px',
                                        boxShadow: '0 10px 30px rgba(89, 189, 101, 0.3)'
                                    }}>
                                        <BiCodeAlt style={{ fontSize: '32px', color: 'white' }} />
                                    </div>
                                    <h3 style={{
                                        color: '#080a3c',
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        marginBottom: '20px'
                                    }}>
                                        {t('startseite_expertise_softwareentwicklung')}
                                    </h3>
                                    <p style={{
                                        color: '#555',
                                        fontSize: '1rem',
                                        lineHeight: '1.7',
                                        margin: '0'
                                    }}>
                                        {t('startseite_expertise_softwareentwicklung_description')}
                                    </p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <Link href="/kuenstliche-intelligenz">
                                <div className="expertise-card" style={{
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: '25px',
                                    padding: '35px 30px',
                                    border: '1px solid rgba(89, 189, 101, 0.15)',
                                    height: '100%',
                                    transition: 'all 0.4s ease',
                                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '25px',
                                        boxShadow: '0 10px 30px rgba(89, 189, 101, 0.3)'
                                    }}>
                                        <BiBrain style={{ fontSize: '32px', color: 'white' }} />
                                    </div>
                                    <h3 style={{
                                        color: '#080a3c',
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        marginBottom: '20px'
                                    }}>
                                        {t('startseite_expertise_ki_analytics')}
                                    </h3>
                                    <p style={{
                                        color: '#555',
                                        fontSize: '1rem',
                                        lineHeight: '1.7',
                                        margin: '0'
                                    }}>
                                        {t('startseite_expertise_ki_analytics_description')}
                                    </p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <Link href="/it-consulting">
                                <div className="expertise-card" style={{
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: '25px',
                                    padding: '35px 30px',
                                    border: '1px solid rgba(89, 189, 101, 0.15)',
                                    height: '100%',
                                    transition: 'all 0.4s ease',
                                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '25px',
                                        boxShadow: '0 10px 30px rgba(89, 189, 101, 0.3)'
                                    }}>
                                        <BiTrendingUp style={{ fontSize: '32px', color: 'white' }} />
                                    </div>
                                    <h3 style={{
                                        color: '#080a3c',
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        marginBottom: '20px'
                                    }}>
                                        {t('startseite_expertise_it_beratung')}
                                    </h3>
                                    <p style={{
                                        color: '#555',
                                        fontSize: '1rem',
                                        lineHeight: '1.7',
                                        margin: '0'
                                    }}>
                                        {t('startseite_expertise_it_beratung_description')}
                                    </p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <Link href="/app-development">
                                <div className="expertise-card" style={{
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: '25px',
                                    padding: '35px 30px',
                                    border: '1px solid rgba(89, 189, 101, 0.15)',
                                    height: '100%',
                                    transition: 'all 0.4s ease',
                                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '25px',
                                        boxShadow: '0 10px 30px rgba(89, 189, 101, 0.3)'
                                    }}>
                                        <BiMobile style={{ fontSize: '32px', color: 'white' }} />
                                    </div>
                                    <h3 style={{
                                        color: '#080a3c',
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        marginBottom: '20px'
                                    }}>
                                        {t('startseite_expertise_app_development')}
                                    </h3>
                                    <p style={{
                                        color: '#555',
                                        fontSize: '1rem',
                                        lineHeight: '1.7',
                                        margin: '0'
                                    }}>
                                        {t('startseite_expertise_app_development_description')}
                                    </p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <Link href="/web-development">
                                <div className="expertise-card" style={{
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: '25px',
                                    padding: '35px 30px',
                                    border: '1px solid rgba(89, 189, 101, 0.15)',
                                    height: '100%',
                                    transition: 'all 0.4s ease',
                                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '25px',
                                        boxShadow: '0 10px 30px rgba(89, 189, 101, 0.3)'
                                    }}>
                                        <BiLogoChrome style={{ fontSize: '32px', color: 'white' }} />
                                    </div>
                                    <h3 style={{
                                        color: '#080a3c',
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        marginBottom: '20px'
                                    }}>
                                        {t('startseite_expertise_web_development')}
                                    </h3>
                                    <p style={{
                                        color: '#555',
                                        fontSize: '1rem',
                                        lineHeight: '1.7',
                                        margin: '0'
                                    }}>
                                        {t('startseite_expertise_web_development_description')}
                                    </p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <Link href="/business-analytics">
                                <div className="expertise-card" style={{
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    borderRadius: '25px',
                                    padding: '35px 30px',
                                    border: '1px solid rgba(89, 189, 101, 0.15)',
                                    height: '100%',
                                    transition: 'all 0.4s ease',
                                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '25px',
                                        boxShadow: '0 10px 30px rgba(89, 189, 101, 0.3)'
                                    }}>
                                        <BiUserCheck style={{ fontSize: '32px', color: 'white' }} />
                                    </div>
                                    <h3 style={{
                                        color: '#080a3c',
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        marginBottom: '20px'
                                    }}>
                                        {t('startseite_expertise_bi')}
                                    </h3>
                                    <p style={{
                                        color: '#555',
                                        fontSize: '1rem',
                                        lineHeight: '1.7',
                                        margin: '0'
                                    }}>
                                        {t('startseite_expertise_bi_description')}
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                </FadeInAnimation>

                <FadeInAnimation direction="up" delay={300}>
                    <div className="text-center mt-5">
                        <p style={{
                            fontSize: '1.1rem',
                            color: '#666',
                            lineHeight: '1.7',
                            maxWidth: '800px',
                            margin: '0 auto',
                            fontStyle: 'italic'
                        }} dangerouslySetInnerHTML={{ __html: t('startseite_expertise_description3') }} />
                    </div>
                </FadeInAnimation>
            </div>


            <style jsx>{`
        .expertise-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 50px rgba(89, 189, 101, 0.15);
          border-color: rgba(89, 189, 101, 0.3);
        }
        
        .expertise-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(89, 189, 101, 0.1), transparent);
          transition: left 0.5s;
        }
        
        .expertise-card:hover::before {
          left: 100%;
        }
        
        @media (max-width: 768px) {
          h2 {
            font-size: 2.4rem !important;
          }
          
          .col-lg-4 {
            margin-bottom: 25px !important;
          }
        }
      `}</style>
        </section>
    );
};

export default StartseiteExpertise; 